import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../atoms';
import { UilAngleDown, UilAngleUp } from '@iconscout/react-unicons';

const DropdownMenu = (props) => {
  const {
    className,
    variant,
    theme,
    content = 'label-only',
    icon,
    children,
    label = 'Dropdown',
    otherAction,
    top = 'top-10',
  } = props;

  const [expand, setExpand] = React.useState(false);

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const refDate = React.useRef(null);

  const handleClickOutside = (event) => {
    if (refDate && !refDate.current.contains(event.target)) {
      setExpand(false);
    }
  };

  return (
    <div className="relative flex justify-end" ref={refDate}>
      <Button
        icon={icon}
        theme={theme}
        variant={variant}
        action={() => {
          setExpand(!expand);
          otherAction && otherAction;
        }}
        content={content}
        className={variant === 'transparent' && theme === 'gray-davys' ? 'hover:bg-gray-culture hover:rounded-lg' : ''}
      >
        <div className="flex items-center bold-text-2">
          <span className="mr-2">{label}</span>
          {expand ? <UilAngleUp /> : <UilAngleDown />}
        </div>
      </Button>
      {expand && (
        <ul
          style={{ zIndex: 57 }}
          className={`${!className && top}  w-auto rounded-lg shadow-lg absolute bg-neutral-light ${className && className}`}
          onClick={() => setExpand(false)}
        >
          {children}
        </ul>
      )}
    </div>
  );
};

DropdownMenu.propTypes = {
  variant: PropTypes.string,
  className: PropTypes.string,
  theme: PropTypes.string,
  content: PropTypes.string,
  label: PropTypes.string,
  otherAction: PropTypes.func,
};

export default DropdownMenu;
